"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElectricityInstallationProfile = exports.GasInstallationProfile = void 0;
/**
 * Also called "verbruiksprofielen".
 * Set by the operator, describes the maximum usages allowed.
 * G1A are for homes with less than 170.000m3 usages, G2A for buildings with usages larger than that.
 */
var GasInstallationProfile;
(function (GasInstallationProfile) {
    GasInstallationProfile["G1A"] = "G1A";
    GasInstallationProfile["G2A"] = "G2A";
})(GasInstallationProfile = exports.GasInstallationProfile || (exports.GasInstallationProfile = {}));
/**
 * Also called "verbruiksprofielen".
 * Set by the operator, describes the maximum usages allowed.
 * Everything started with E1 is for homes with less than equal to 3x25 ampere usage.
 * E2 are for homes with usages between 3x25 and 3x80.
 * We also have E3, but that are for huge buildings or territories.
 */
var ElectricityInstallationProfile;
(function (ElectricityInstallationProfile) {
    ElectricityInstallationProfile["E1A"] = "E1A";
    ElectricityInstallationProfile["E1B"] = "E1B";
    ElectricityInstallationProfile["E1C"] = "E1C";
    ElectricityInstallationProfile["E2A"] = "E2A";
    ElectricityInstallationProfile["E2B"] = "E2B";
})(ElectricityInstallationProfile = exports.ElectricityInstallationProfile || (exports.ElectricityInstallationProfile = {}));
